import { RecipeImage } from '@library/menu-service'
import moment from 'moment'

type RecipeSurcharge = {
  pricePerPortion: number
} | null

type RecipeSurchargeDetails = {
  surcharge?: RecipeSurcharge
  surchargeLabel?: string | null
}

export const getMoodImage = (images: RecipeImage[]): RecipeImage['crops'] => {
  const defaultImageCrops = images?.[0]?.crops || []
  const moodImageCrops = images?.find((image) => image.type === 'mood-image')?.crops

  return moodImageCrops || defaultImageCrops
}

export const getDefaultImage = (srcs: RecipeImage['crops']) => {
  const sortedSrcs = srcs.slice().sort((a, b) => b.width - a.width)
  const midpointInArray = Math.floor(sortedSrcs.length / 2)

  return sortedSrcs[midpointInArray]?.url || ''
}

export const getSrcSet = (srcs: RecipeImage['crops']): string => {
  return srcs.map(({ url, width }) => `${url} ${width}w`).join()
}

const formatSurchargeValue = (pricePerPortion: number) => {
  if (pricePerPortion === 0) {
    return null
  }

  const formattedValue = Math.abs(pricePerPortion / 100).toFixed(2)

  return pricePerPortion < 0 ? `Save £${formattedValue}` : `+£${formattedValue}`
}

export const getSurchargeLabel = ({ surcharge, surchargeLabel }: RecipeSurchargeDetails) => {
  const formattedSurcharge = formatSurchargeValue(surcharge?.pricePerPortion || 0)

  return surchargeLabel || (formattedSurcharge ? `${formattedSurcharge} per portion` : null)
}

export const formatDeliveryTime = (time: string) => {
  const deliveryTime = moment(time, ['HH:mm:ss', 'H:mm:ss', 'HH:mm', 'H:mm', 'h:mmA'], true)

  return deliveryTime.isValid() ? deliveryTime.format('h:mmA') : time
}
